import React, { useEffect, useState } from "react";
import Header2 from "../../Layout/Header2";
import "./WinnersAboutUsBlue.css";
import headlogo from "../../Images/Isolation_Mode.png";
import isolation from "../../Images/Isolation_Mode (1).png";
import isolation2 from "../../Images/Isolation_Mode (2).png";
import isolation3 from "../../Images/Isolation_Mode (3).png";
import img1 from "../../Images/Rectangle 20 (4).png";
import img2 from "../../Images/Rectangle 424.png";
import img3 from "../../Images/Rectangle 425.png";
import img4 from "../../Images/Rectangle 426.png";
import FavPropertiesBlue from "./FavPropertiesBlue";
import WinnersClient from "../WinnersHome/WinnersClient";
import AchievementsBlue from "./AchievementsBlue";
import WhyChooseUsBlue from "./WhyChooseUsBlue";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { WinnersHeaderBlue } from "../WinnersHome/WinnerBlueLan/WinnersHeaderBlue";
import DownloadApp from "../WinnersHome/DownloadApp";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";
import { ShieldCheck } from "lucide-react";


const Counter = ({ end, label }) => {
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  useEffect(() => {
    if (inView) {
      let start = 0;
      const duration = 2000; // total duration of animation in ms
      const increment = Math.ceil(end / (duration / 20));

      const counter = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(counter);
        } else {
          setCount(start);
        }
      }, 20);
    }
  }, [inView, end]);


  return (
    <div className="achievement_box_blue" ref={ref}>
      <p className="achieve_number_para_blue">{count.toLocaleString()}+</p>
      <p className="achive_name_blue">{label}</p>
    </div>
  );
};

const WinnersAboutUsBlue = () => {
  useEffect(() => {
    AOS.init({
      duration: 900,
      once: false,
      mirror: true,
      easing: "ease-in-out",
      offset: 80,
      anchorPlacement: "top-bottom",
    });

    // Refresh after the first render
    setTimeout(() => {
      AOS.refresh();
    }, 100);
  }, []);

  var settings = {
    // dots: false,
    // infinite: true,
    // speed: 500,
    // slidesToShow: 4,
    // slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 3500,
    // speed: 800,

    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,

    // responsive: [
    //   {
    //     breakpoint: 999,
    //     settings: {
    //       slidesToShow: 3,
    //     },
    //   },
    //   {
    //     breakpoint: 699,
    //     settings: {
    //       slidesToShow: 3,
    //     },
    //   },
    //   {
    //     breakpoint: 600,
    //     settings: {
    //       slidesToShow: 1,
    //     },
    //   },
    //   {
    //     breakpoint: 499,
    //     settings: {
    //       slidesToShow: 1,
    //     },
    //   },
    // ],
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  const navigate = useNavigate();

  return (
    <>
      <WinnersHeaderBlue />
      {/* <section className="about_us_section_blue">
        <div className="about_us_container_blue">
         
          <WinnersHeaderBlue />
          <div>
            <h1 className="about_head_blue">
              About Us
              <span>
                <img className="img_logo_blue" src={headlogo} alt="Logo decoration" />
              </span>
            </h1>
            <p className="about_head_para_blue">
              Who We Are – Your Trusted Real Estate Data Partner We are a real
              estate data provider company based in NCR, specializing in
              property listings, price trends, and verified sales & rental
              information owners properties data across Gurgaon, Noida, and
              South Delhi. Our mission is simple: Helping real estate
              professionals’ brokers, consultants with real time accurate data
              that drives results. • No guesswork. • No outdated information.
              • Just pure, actionable insights to help you close deals faster.
              With years of experience and a growing network, we serve brokers,
              agencies, developers, and investors who need reliable data to
              scale their business. 👉 Because in real estate, information is
              everything — and we make sure you always have the right one.
            </p>
          </div>
          <img className="isolation_img_1_blue" src={isolation} alt="Decorative shape 1" />
          <img className="isolation_img_2_blue" src={isolation2} alt="Decorative shape 2" />
          <img className="isolation_img_3_blue" src={isolation3} alt="Decorative shape 3" />

          <div className="about_images_div_wrapper_blue">
            <Slider {...settings}>
              <div className="about_img_div_1_blue" id="img1">
                <img src={img1} alt="Team/Property Slide 1" />
              </div>
              <div className="about_img_div_2_blue" id="img2">
                <img src={img2} alt="Team/Property Slide 2" />
              </div>
              <div className="about_img_div_1_blue" id="img3">
                <img src={img3} alt="Team/Property Slide 3" />
              </div>
              <div className="about_img_div_2_blue" id="img4">
                <img src={img4} alt="Team/Property Slide 4" />
              </div>
            </Slider>
          </div>

        </div>
      </section> */}
      {/* <section className="about-hero-blue">
        <div className="about-hero-container-blue">

         
          <div className="about-content-blue">
            <span className="about-badge-blue">
              About Winners
            </span>

            <h1 className="about-title-blue">
              Empowering Real Estate
              <span> With Accurate Market Intelligence</span>
            </h1>

            <p className="about-description-blue">
              We provide verified property listings, sales records,
              rental insights and market trends across Gurgaon,
              Noida,South Delhi and many Location.
            </p>

            <div className="about-stats-blue">
              <div>
                <h3>
                  <Counter end={25000} />
                </h3>
                <span>Happy Client</span>
              </div>

              <div>
                <h3>
                  <Counter end={350} />
                </h3>
                <span>Complete Projects</span>
              </div>

              <div>
                <h3>
                  <Counter end={80000} />
                </h3>
                <span>Property Sales</span>
              </div>

              <div>
                <h3>
                  <Counter end={15} />
                </h3>
                <span>Years Experience</span>
              </div>
            </div>

            <div className="about-btns-blue">
              <button className="primary-btn-blue" onClick={() => navigate("/propertylist")}>
                Explore Data
              </button>

              <button
                className="secondary-btn-blue"
                onClick={() => {
                  document
                    .getElementById("contact-us-section")
                    ?.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    });
                }}
              >
                Contact Us
              </button>
            </div>
          </div>

    
          <div className="about-gallery-blue">

            <div className="main-image-blue">
              <img src={img1} alt="" />
            </div>

            <div className="small-image-blue top">
              <img src={img2} alt="" />
            </div>

            <div className="small-image-blue bottom">
              <img src={img3} alt="" />
            </div>

            <div className="floating-card-blue">
              <h4>Verified Data</h4>
              <p>Real-time property intelligence</p>
            </div>

          </div>

        </div>
      </section> */}

      <section className="about-company-section">

        <div className="about-company-wrapper city-uni-container2 ab">

          {/* LEFT IMAGE */}

          <div
            className="about-company-left"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-once="false"
          >

            <div className="about-main-image">

              <img src={img1} alt="About Winners" />

              <div
                className="about-exp-card"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <h2>15+</h2>
                <span>Years Experience</span>
              </div>

              <div
                className="about-verify-card"
                data-aos="zoom-in"
                data-aos-delay="400"
              >
                {/* <i className="fa-solid fa-circle-check"></i> */}
                <ShieldCheck />

                <div>
                  <h4>Verified Data</h4>
                  <p>100% Genuine Property Insights</p>
                </div>
              </div>

            </div>

          </div>

          {/* RIGHT CONTENT */}

          <div
            className="about-company-right"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-once="false"
          >

            <span className="about-small-tag">
              About WINNERS
            </span>

            <h2>

              Your Trusted
              <span> Real Estate Data Partner</span>

            </h2>

            <p>

              We are a real estate data provider company based in NCR,
              specializing in property listings, verified sales,
              rental information, owner properties and market trends
              across Gurgaon, Noida and South Delhi.

            </p>

            {/* <div className="about-check-list">

        <div>
          <i className="fa-solid fa-circle-check"></i>
          No Guesswork
        </div>

        <div>
          <i className="fa-solid fa-circle-check"></i>
          No Outdated Information
        </div>

        <div>
          <i className="fa-solid fa-circle-check"></i>
          Accurate Real-Time Property Data
        </div>

        <div>
          <i className="fa-solid fa-circle-check"></i>
          Trusted by Brokers & Developers
        </div>

      </div> */}

            <p className="about-last-text">

              With years of experience and a growing network, we help
              brokers, agencies, developers and investors make
              confident decisions using reliable property intelligence.

              <strong>

                Information is everything—and we make sure you always
                have the right one.

              </strong>

            </p>

            <button
              className="about-company-btn"
              onClick={() => navigate("/propertylist")}
            >
              Explore Properties
            </button>

          </div>

        </div>

      </section>
      <AchievementsBlue />
      <section className="about-stats-section">

        <div className="city-uni-container2">

          <div className="about-stats-wrapper">

            <div className="stats-title">
              <span>OUR ACHIEVEMENTS</span>
              <h2>Trusted By Thousands</h2>
            </div>

            <div className="stats-items">

              <div className="stats-item">
                <h3>
                  <Counter end={25000} />
                </h3>
                <p>Happy Clients</p>
              </div>

              <div className="stats-divider"></div>

              <div className="stats-item">
                <h3>
                  <Counter end={350} />
                </h3>
                <p>Completed Projects</p>
              </div>

              <div className="stats-divider"></div>

              <div className="stats-item">
                <h3>
                  <Counter end={80000} />
                </h3>
                <p>Property Sales</p>
              </div>

              <div className="stats-divider"></div>

              <div className="stats-item">
                <h3>
                  <Counter end={15} />
                </h3>
                <p>Years Experience</p>
              </div>

            </div>

          </div>

        </div>

      </section>
      <FavPropertiesBlue />
      <WhyChooseUsBlue />
      <WinnersClient center={"center"} />

      <DownloadApp />
    </>
  );
};

export default WinnersAboutUsBlue;
